/** @format */

import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useUpdateFellowProfileMutation } from "store/services/adminAPI";
import { employmentList } from "utils/constant.data";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Fragment } from "react";
import dayjs from "dayjs";
import {
  extractErrorMessage,
  Industries,
  replaceUnderscoresWithSpaces,
} from "utils/strings";
import { numbers, options } from "utils/constant.data";

const Profession = ({ currentProfile, setActiveTab }) => {
  const [updateFellowProfile, { isLoading: updating }] =
    useUpdateFellowProfileMutation();

  const handleSubmit = async (values) => {
  let profileData = {};

  if (values.employment_status === "self_employed") {
    profileData = {
      what_date_was_your_startup_founded: values.what_date_was_your_startup_founded,
      startup_short_bio: values.startup_short_bio,
      has_raised_funding: values.has_raised_funding,
      was_your_startup_founded_after_3mtt: values.was_your_startup_founded_after_3mtt,
      company_years_worked: values?.company_years_worked,
      company_industry: values?.company_industry,
      name_of_your_startup: values?.name_of_your_startup,
    };
  } else if (values.employment_status === "employed") {
    profileData = {
      company_resumption_date: values.company_resumption_date 
        ? dayjs(values.company_resumption_date).format("YYYY-MM-DD") 
        : undefined,
      company_current_monthly_salary: values.company_current_monthly_salary,
      previous_salary_before_company: values.previous_salary_before_company,
      company_role_influenced_by_3mtt: values.company_role_influenced_by_3mtt,
      is_applying_3mtt_skills_at_company: values.is_applying_3mtt_skills_at_company,
      has_existing_business: values.has_existing_business,
      future_interest_in_starting_business: values.future_interest_in_starting_business,
      company_worked_at: values?.company_worked_at,
      company_years_worked: values?.company_years_worked,
      company_job_title: values?.company_job_title,
      company_industry: values?.company_industry,
    };
  }

  // Filter out empty fields
  const filteredProfileData = Object.fromEntries(
    Object.entries(profileData).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined
    )
  );

  await updateFellowProfile({
    employment_status: values.employment_status,
    ...filteredProfileData,
  })
    .unwrap()
    .then(() => {
      toast.success("✔️ Profile updated !", {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
      });
      setActiveTab("learning");
    })
    .catch((error) => {
      const formattedError = extractErrorMessage(error);
      Swal.fire({
        title: replaceUnderscoresWithSpaces(error?.data?.code) || "Error Occured",
        text: formattedError,
        iconHtml: `<i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>`,
        showCloseButton: true,
        customClass: { icon: "no-border" },
        confirmButtonText: "Try Again",
      });
    });
};


  const formik = useFormik({
    initialValues: {
      employment_status: currentProfile?.employment_status || "",
      company_worked_at: currentProfile?.company_worked_at || "", //input
      company_years_worked: currentProfile?.company_years_worked || 0,
      company_job_title: currentProfile?.company_job_title || "", //input
      company_industry: currentProfile?.company_industry || "",
      name_of_your_startup: currentProfile?.name_of_your_startup || "",

      company_resumption_date: currentProfile?.company_resumption_date || "",
      company_current_monthly_salary:
        currentProfile?.company_current_monthly_salary ?? 0,
      previous_salary_before_company:
        currentProfile?.previous_salary_before_company ?? 0,
      company_role_influenced_by_3mtt:
        currentProfile?.company_role_influenced_by_3mtt ?? false,
      is_applying_3mtt_skills_at_company:
        currentProfile?.is_applying_3mtt_skills_at_company ?? false,
      has_existing_business: currentProfile?.has_existing_business ?? false,
      future_interest_in_starting_business:
        currentProfile?.future_interest_in_starting_business ?? false,

      what_date_was_your_startup_founded:
        currentProfile?.what_date_was_your_startup_founded ?? "",
      startup_short_bio: currentProfile?.startup_short_bio ?? "",
      has_raised_funding: currentProfile?.has_raised_funding ?? false,
      was_your_startup_founded_after_3mtt:
        currentProfile?.was_your_startup_founded_after_3mtt ?? false,
    },
    onSubmit: handleSubmit,
    enableReinitialize: true,
    validationSchema: FormSchema,
  });

  return (
    <div className="basic-form">
      <h5>Professional Experience</h5>

      <form
        onSubmit={formik.handleSubmit}
        className={updating ? "disabled" : ""}
      >
        <div className="row g-3 mb-3">
          <div className="col-md-12">
            <label className="mb-3">
              <strong>Employment Status</strong>
            </label>
            <div className="d-flex align-items-center justify-content-between mb-3">
              {employmentList.map((item, index) => {
                return (
                  <button
                    key={index}
                    type="button"
                    className={`btn btn-outline-grey flex-grow me-2 ${
                      formik?.values?.employment_status === item?.value
                        ? "active"
                        : ""
                    }`}
                    onClick={() =>
                      formik.setFieldValue("employment_status", item?.value)
                    }
                  >
                    {item?.label}
                  </button>
                );
              })}
            </div>
          </div>

          {(formik?.values?.employment_status === "employed" ||
            formik?.values?.employment_status === "self_employed") && (
            <div className="row">
              <div className="col-md-4 mb-4">
                <label className="mb-1">
                  <strong>Company Name</strong>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name={formik?.values?.employment_status === "self_employed" ? "name_of_your_startup" : "company_worked_at"}
                  id={formik?.values?.employment_status === "self_employed" ? "name_of_your_startup" : "company_worked_at"}
                  value = {formik?.values?.employment_status === "self_employed" ? formik?.values?.name_of_your_startup : formik?.values?.company_worked_at}
                  onChange={formik.handleChange}
                  placeholder="Company Name"
                  {...formik.getFieldProps(formik?.values?.employment_status === "self_employed" ? "name_of_your_startup" : "company_worked_at")}
                />
                {formik.errors?.company_worked_at && (
                  <span className="text-danger">
                    {formik.errors?.company_worked_at}
                  </span>
                )}
              </div>

              <div className="col-md-4 mb-4">
                <label className="mb-1">
                  <strong>Years of Working Experience</strong>
                </label>
                <select
                  id="company_years_worked"
                  name="company_years_worked"
                  value={formik.values.company_years_worked}
                  className="form-control"
                  onChange={(e) => {
                    const selectedSkill = e.target.value;
                    formik.setFieldValue("company_years_worked", selectedSkill);
                  }}
                  {...formik.getFieldProps("company_years_worked")}
                >
                  {numbers.map((skill) => {
                    return <option value={skill}>{skill}</option>;
                  })}
                </select>
                {formik.errors.company_years_worked ? (
                  <div className="text-danger mt-2 fs-12">
                    {formik.errors.company_years_worked}
                  </div>
                ) : null}
              </div>

              <div className="col-md-4 mb-4">
                <label className="mb-1">
                  <strong>What industry Sector do you work in?</strong>
                </label>
                <select
                  id="company_industry"
                  name="company_industry"
                  value={formik.values.company_industry}
                  className="form-control"
                  onChange={(e) => {
                    const selectedSkill = e.target.value;
                    formik.setFieldValue("company_industry", selectedSkill);
                  }}
                  {...formik.getFieldProps("company_industry")}
                >
                  {Industries.map((skill) => {
                    return <option value={skill}>{skill}</option>;
                  })}
                </select>
                {formik.errors.company_industry ? (
                  <div className="text-danger mt-2 fs-12">
                    {formik.errors.company_industry}
                  </div>
                ) : null}
              </div>

              {formik?.values?.employment_status === "employed" && (
                <Fragment>
                  <div className="col-md-4 mb-4">
                    <label className="mb-1">
                      <strong>Job Title</strong>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="company_job_title"
                      id="company_job_title"
                      value={formik.values?.company_job_title}
                      onChange={formik.handleChange}
                      placeholder="Job Title"
                      {...formik.getFieldProps("company_job_title")}
                    />
                    {formik.errors?.company_job_title && (
                      <span className="text-danger">
                        {formik.errors?.company_job_title}
                      </span>
                    )}
                  </div>

                  <div className="col-md-4 mb-4">
                    <label className="mb-1">
                      <strong>What Date did you start your job?</strong>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="company_resumption_date"
                      id="company_resumption_date"
                      value={formik.values?.company_resumption_date}
                      onChange={formik.handleChange}
                      placeholder="Job Title"
                      {...formik.getFieldProps("company_resumption_date")}
                    />
                    {formik.errors?.company_resumption_date && (
                      <span className="text-danger">
                        {formik.errors?.company_resumption_date}
                      </span>
                    )}
                  </div>

                  <div className="col-md-4 mb-4">
                    <label className="mb-1">
                      <strong>
                        How much is your monthly salary at this job?
                      </strong>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="company_current_monthly_salary"
                      id="company_current_monthly_salary"
                      value={formik.values?.company_current_monthly_salary}
                      onChange={formik.handleChange}
                      placeholder="Company Name"
                      {...formik.getFieldProps(
                        "company_current_monthly_salary"
                      )}
                    />
                    {formik.errors?.company_current_monthly_salary && (
                      <span className="text-danger">
                        {formik.errors?.company_current_monthly_salary}
                      </span>
                    )}
                  </div>

                  <div className="col-md-4 mb-4 form-balance">
                    <label className="mb-1">
                      <strong>
                        How much was your monthly salary before this job?
                      </strong>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="previous_salary_before_company"
                      id="previous_salary_before_company"
                      value={formik.values?.previous_salary_before_company}
                      onChange={formik.handleChange}
                      placeholder="Company Name"
                      {...formik.getFieldProps(
                        "previous_salary_before_company"
                      )}
                    />
                    {formik.errors?.previous_salary_before_company && (
                      <span className="text-danger">
                        {formik.errors?.previous_salary_before_company}
                      </span>
                    )}
                  </div>

                  <div className="col-md-4 mb-4 form-balance">
                    <label className="mb-1">
                      <strong>Did you secure this job through 3MTT?</strong>
                    </label>
                    <div className="d-flex align-items-center justify-content-between">
                      {options.map((item, index) => {
                        return (
                          <button
                            key={index}
                            type="button"
                            className={`btn btn-outline-grey flex-grow me-2 ${
                              formik?.values
                                ?.company_role_influenced_by_3mtt ===
                              item?.value
                                ? "active"
                                : ""
                            }`}
                            onClick={() => {
                              formik.setFieldValue(
                                "company_role_influenced_by_3mtt",
                                item?.value
                              );
                            }}
                          >
                            {item?.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  <div className="col-md-4 mb-4 form-balance">
                    <label className="mb-1">
                      <strong>
                        Are you currently applying your 3MTT training at your
                        job?
                      </strong>
                    </label>
                    <div className="d-flex align-items-center justify-content-between ">
                      {options.map((item, index) => {
                        return (
                          <button
                            key={index}
                            type="button"
                            className={`btn btn-outline-grey flex-grow me-2 ${
                              formik?.values
                                ?.is_applying_3mtt_skills_at_company ===
                              item?.value
                                ? "active"
                                : ""
                            }`}
                            onClick={() => {
                              formik.setFieldValue(
                                "is_applying_3mtt_skills_at_company",
                                item?.value
                              );
                            }}
                          >
                            {item?.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  <div className="col-md-4 mb-4 form-balance">
                    <label className="mb-1">
                      <strong>
                        Do you have an existing business or startup?
                      </strong>
                    </label>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      {options.map((item, index) => {
                        return (
                          <button
                            key={index}
                            type="button"
                            className={`btn btn-outline-grey flex-grow me-2 ${
                              formik?.values?.has_existing_business ===
                              item?.value
                                ? "active"
                                : ""
                            }`}
                            onClick={() => {
                              formik.setFieldValue(
                                "has_existing_business",
                                item?.value
                              );
                            }}
                          >
                            {item?.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  <div className="col-md-4 mb-4 form-balance">
                    <label className="mb-1">
                      <strong>
                        Are you interested in starting a business in the future?
                      </strong>
                    </label>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      {options.map((item, index) => {
                        return (
                          <button
                            key={index}
                            type="button"
                            className={`btn btn-outline-grey flex-grow me-2 ${
                              formik?.values
                                ?.future_interest_in_starting_business ===
                              item?.value
                                ? "active"
                                : ""
                            }`}
                            onClick={() => {
                              formik.setFieldValue(
                                "future_interest_in_starting_business",
                                item?.value
                              );
                            }}
                          >
                            {item?.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                </Fragment>
              )}

              {formik?.values?.employment_status === "self_employed" && (
                <Fragment>
                  <div className="col-md-4 mb-4">
                    <label className="mb-1">
                      <strong>When was your startup founded?</strong>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="what_date_was_your_startup_founded"
                      id="what_date_was_your_startup_founded"
                      value={formik.values?.what_date_was_your_startup_founded}
                      onChange={formik.handleChange}
                      placeholder="Job Title"
                      {...formik.getFieldProps(
                        "what_date_was_your_startup_founded"
                      )}
                    />
                    {formik.errors?.what_date_was_your_startup_founded && (
                      <span className="text-danger">
                        {formik.errors?.what_date_was_your_startup_founded}
                      </span>
                    )}
                  </div>

                  <div className="col-md-4 mb-4 form-balance">
                    <label className="mb-1">
                      <strong>Short Bio about your company</strong>
                    </label>
                    <div>
                      <textarea
                        type="text"
                        className="form-control"
                        name="startup_short_bio"
                        id="startup_short_bio"
                        value={formik.values?.startup_short_bio}
                        onChange={formik.handleChange}
                        placeholder="Startup Short Bio"
                        {...formik.getFieldProps("startup_short_bio")}
                      />
                      {formik.errors?.startup_short_bio && (
                        <span className="text-danger">
                          {formik.errors?.startup_short_bio}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-4 mb-4">
                    <label className="mb-1">
                      <strong>Have you raised funding?</strong>
                    </label>
                    <div className="d-flex align-items-center justify-content-between">
                      {options.map((item, index) => {
                        return (
                          <button
                            key={index}
                            type="button"
                            className={`btn btn-outline-grey flex-grow me-2 ${
                              formik?.values?.has_raised_funding === item?.value
                                ? "active"
                                : ""
                            }`}
                            onClick={() => {
                              formik.setFieldValue(
                                "has_raised_funding",
                                item?.value
                              );
                            }}
                          >
                            {item?.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  <div className="col-md-4 mb-4 form-balance">
                    <label className="mb-1">
                      <strong>
                        Was your startup founded after/during 3MTT?
                      </strong>
                    </label>
                    <div className="d-flex align-items-center justify-content-between ">
                      {options.map((item, index) => {
                        return (
                          <button
                            key={index}
                            type="button"
                            className={`btn btn-outline-grey flex-grow me-2 ${
                              formik?.values
                                ?.was_your_startup_founded_after_3mtt ===
                              item?.value
                                ? "active"
                                : ""
                            }`}
                            onClick={() => {
                              formik.setFieldValue(
                                "was_your_startup_founded_after_3mtt",
                                item?.value
                              );
                            }}
                          >
                            {item?.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                </Fragment>
              )}
            </div>
          )}
        </div>

        <div className="d-flex justify-content-end">
          <button
            onClick={() => setActiveTab("education")}
            type="button"
            className="submit btn btn-outline-grey  me-2"
          >
            Back
          </button>
          <button
            type="submit"
            className="submit btn btn-pigment-green"
            disabled={updating}
            // onClick={() => {
            //   handleSubmit();
            // }}
          >
            {updating ? (
              <span
                role="button"
                aria-hidden="true"
                className="spinner-border spinner-border-sm ms-2"
              ></span>
            ) : (
              "Save & Proceed"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Profession;

const FormSchema = Yup.object().shape({
  employment_status: Yup.string(),
    // .required("Employment status is required"),

  company_worked_at: Yup.string().when("employment_status", {
    is: (employment_status) =>
      employment_status === "employed" || employment_status === "self_employed",
    then: () => 
      Yup.string()
        // .required("Company name is required"),
    // otherwise: () => Yup.string(),
  }),
  company_years_worked: Yup.string().when("employment_status", {
    is: (employment_status) =>
      employment_status === "employed" || employment_status === "self_employed",
    then: () => 
      Yup.string()
        // .required("Years of experience is required"),
    // otherwise: () => Yup.string(),
  }),
  company_industry: Yup.string().when("employment_status", {
    is: (employment_status) =>
      employment_status === "employed" || employment_status === "self_employed",
    then: () => 
      Yup.string()
        // .required("Company Industry is required"),
    // otherwise: () => Yup.string(),
  }),

  company_job_title: Yup.string().when("employment_status", {
    is: (employment_status) => employment_status === "employed",
    then: () => 
      Yup.string()
        // .required("Job title is required"),
    // otherwise: () => Yup.string(),
  }),
  company_resumption_date: Yup.string().when("employment_status", {
    is: (employment_status) => employment_status === "employed",
    then: () => 
      Yup.string()
        // .required("Resumption date is required"),
    // otherwise: () => Yup.string(),
  }),
  company_current_monthly_salary: Yup.string().when("employment_status", {
    is: (employment_status) => employment_status === "employed",
    then: () => 
      Yup.number()
        // .required("Monthly Salary is required"),
    // otherwise: () => Yup.number(),
  }),
  previous_salary_before_company: Yup.string().when("employment_status", {
    is: (employment_status) => employment_status === "employed",
    then: () => 
      Yup.number()
        // .required("Previous Salary is required"),
    // otherwise: () => Yup.number(),
  }),
  company_role_influenced_by_3mtt: Yup.string().when("employment_status", {
    is: (employment_status) => employment_status === "employed",
    then: () => 
      Yup.boolean()
        // .required("This option is required"),
    // otherwise: () => Yup.boolean(),
  }),
  is_applying_3mtt_skills_at_company: Yup.string().when("employment_status", {
    is: (employment_status) => employment_status === "employed",
    then: () => 
      Yup.boolean()
        // .required("This option is required"),
    // otherwise: () => Yup.boolean(),
  }),
  has_existing_business: Yup.string().when("employment_status", {
    is: (employment_status) => employment_status === "employed",
    then: () => 
      Yup.boolean(),
        // .required("This option is required"),
    // otherwise: () => Yup.boolean(),
  }),
  future_interest_in_starting_business: Yup.string().when("employment_status", {
    is: (employment_status) => employment_status === "employed",
    then: () => 
      Yup.boolean(),
        // .required("Future Interest is required"),
    // otherwise: () => Yup.boolean(),
  }),

  what_date_was_your_startup_founded: Yup.string().when("employment_status", {
    is: (employment_status) => employment_status === "self_employed",
    then: () => 
      Yup.string(),
        // .required("Startup founded date is required"),
    // otherwise: () => Yup.string(),
  }),
  startup_short_bio: Yup.string().when("employment_status", {
    is: (employment_status) => employment_status === "self_employed",
    then: () => 
      Yup.string()
        // .required("Startup Bio is required"),
    // otherwise: () => Yup.string(),
  }),
  has_raised_funding: Yup.string().when("employment_status", {
    is: (employment_status) => employment_status === "self_employed",
    then: () => Yup.boolean()
      // .required("This option is required"),
    // otherwise: () => Yup.boolean(),
  }),
  was_your_startup_founded_after_3mtt: Yup.string().when("employment_status", {
    is: (employment_status) => employment_status === "self_employed",
    then: () => Yup.boolean()
      // .required("This option is required"),
    // otherwise: () => Yup.boolean(),
  }),
});

